import { EndpointDefinition } from "../_sdk/types/common";

export const apiName = "icons";

export const endpoints: { [key: string]: EndpointDefinition } = {
    recordIconSelection: {
        route: "/icons/:userId/record",
        method: "POST",
    },
    getUserRecommendations: {
        route: "/icons/:userId/recommendations",
        method: "GET",
    },
};
